// Standalone /methods page — the hub that links to every methodology reference (Data Dictionary,
// Data Model, Play Engine, Skill Layer). Routed at the top level in index.js (same pattern as
// /data-dictionary). Content is the self-contained static doc in public/methods.html, embedded in
// a full-viewport iframe so its page-level styles stay fully isolated.
export default function Methods() {
  return (
    <iframe
      title="Pollis — Methods"
      src={`${process.env.PUBLIC_URL || ""}/methods.html`}
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        border: "none",
      }}
    />
  );
}
